/**
 * @ngdoc service
 * @name cart
 *
 * @description Cart getter mock.
 */
module.factory('cart', ['drupal', '$http', '$state', 'lodash', '$q', '$timeout', '$window', function (drupal, $http, $state, lodash, $q, $timeout, $window) {
    'use strict';

    var storage = 'cart';

    var expiration; // expiration du panier en cache

    var ShoppingCart = function () {
        this.expiration_delay = 0;

        this.field_membership_price = 34;
        this.field_total_amount = 0;
        this.internships = [];
        this.products = [];
        this.discounts = [];
        this.user = {};
        this.quantity = 0;

        // delivery infos
        this.deliveryTime = 0;
        this.deliveryPrice = 0;

        this.retrieve();
    };

    var showProductAddedModal = function () {
        // TODO : should these texts be in translations ?
        swal({
            title: 'Produit ajouté !',
            text: 'Souhaitez-vous continuer vos achats ou voir votre panier ?',
            icon: 'success',
            buttons: {
                cancel: {
                    text: 'Continuer mes achats',
                    value: false,
                    visible: true,
                    className: 'aqua-form--button', // only 1 class can be set here
                    closeModal: true
                },
                confirm: {
                    text: 'Aller au panier',
                    value: true,
                    visible: true,
                    className: 'aqua-form--button',
                    closeModal: true
                }
            }
        }).then(function (goToCart) {
            if (goToCart) {
                $state.go('cart');
            }
        });
    };

    ShoppingCart.prototype.clear = function () {
        // console.dir($window.localStorage);
        $window.localStorage.removeItem(storage);

        this['internships'] = [];
        this['discounts'] = [];
        this['products'] = [];
        this['user'] = {};

        if (window._paq) {
            try {
                _paq.push(['clearEcommerceCart']);
            } catch (e) { console.error(e); }
        }

        return this.update();
    };

    ShoppingCart.prototype.save = function () {
        $window.localStorage.setItem(storage, angular.toJson(this.toJson()));
    };

    ShoppingCart.prototype.toJson = function () {
        var sJson = {
            internships: this.internships,
            discount: this.discount,
            products: this.products,
            user: this.user
        };
        if (this.expiration_delay) {
            sJson.expiration_date = new Date(new Date().getTime() + (60000 * this.expiration_delay));
        }
        return sJson;
    };

    ShoppingCart.prototype.retrieve = function () {
        var saved = angular.fromJson($window.localStorage[storage]);
        if (saved) {
            if (saved.expiration_date
                && new Date(saved.expiration_date) <= new Date()) {
                this.clear();
            } else {
                this['internships'] = saved['internships'] || [];
                this['discount'] = saved['discount'] || [];
                this['products'] = saved['products'] || [];
                this['user'] = saved['user'] || {};
                this.update();
            }
        }
    };

    ShoppingCart.prototype.quantify = function () {
        var quantity = 0;
        quantity += this.internships.length;
        this.products.forEach(function (product) {
            quantity += product.field_quantity;
        });
        this.quantity = quantity;
    };

    ShoppingCart.prototype.calculate = function () {
        var amount = 0;
        this.internships.forEach(function (internship) {
            if (internship.field_internship.privatized) {
                amount += internship.field_internship.capacity * (internship.field_internship.discount ? internship.field_internship.discountPrice : internship.field_internship.price);
            }
            else {
                amount += internship.field_quantity * (internship.field_internship.discount ? internship.field_internship.discountPrice : internship.field_internship.price);
            }
            // add guarantees and options to total amount
            var field_optionsGuarantees = [];
            var flatettened = lodash.chain(internship.participants).map(function (p) { return [p.field_options, p.field_guarantees]}).flatten().flatten().filter({'selected': true}).value();
            flatettened.forEach(function (f) {
                // add option/guarantee cost to total amount
                amount += f.price;
                // add option/guarantee to summary for display purpose only
                var found = lodash.find(field_optionsGuarantees, {'sfid': f.sfid});
                if (found) {
                    found.quantity += 1;
                } else {
                    field_optionsGuarantees.push({
                        'sfid': f.sfid,
                        'quantity': 1,
                        'price': f.price,
                        'name': f.name
                    });
                }
            });
            // store options/guarantee
            internship.field_optionsGuarantees = field_optionsGuarantees;
        });
        this.products.forEach(function (product) {
            amount += product.field_quantity * product.field_product.price;
        });
        // delivery info
        var maxDTProduct = {};
        if (this.products.length) {
            maxDTProduct = lodash.max(this.products, function (p) {
                if (false === p.field_product.hasOwnProperty('deliveryTime')) {
                    return 0;
                }
                return p.field_product.deliveryTime;
            });
            this.deliveryTime = maxDTProduct.field_product.deliveryTime;
        }
        this.deliveryPrice = 0; // TODO: unmock w/ SF

        this.field_total_amount = amount;
    };

    ShoppingCart.prototype.update = function () {
        this.quantify();
        this.calculate();
        this.save();
        this.notifyMatomo();
        return $q.resolve();
    };

    var prepareInternship = function (internship, options) {
        var tmpInt = angular.copy(internship);

        // set privatisation user choice to field
        tmpInt.privatized = options.field_privatized;

        return $q.resolve({
            id: internship.sfid,
            field_quantity: options.field_participants,
            field_internship: tmpInt
        });
    };

    ShoppingCart.prototype.addInternship = function (internship, options) {
        var _self = this;
        //console.log('cart.addInternship:', internship, options);
        return prepareInternship(internship, options)
            .then(function (r) {
                _self.internships.push(r);
            })
            .then(function () {
                // notify user
                showProductAddedModal();
                return _self.update();
            });
    };

    ShoppingCart.prototype.removeInternship = function (internship) {
        //console.log('cart.removeInternship:', internship);
        var index = lodash.findIndex(this.internships, { id: internship.sfid });
        if (index > -1) {
            this.internships.splice(index, 1);
        }
        return this.update();
    };

    ShoppingCart.prototype.addProduct = function (product) {
        //console.log('cart.addProduct:', product);
        var current = lodash.find(this.products, { id: product.sfid });
        if (current) {
            if (current.field_quantity < current.field_product.stock) {
                ++current.field_quantity;
            }
        } else {
            this.products.push({
                id: product.sfid,
                field_quantity: 1,
                field_product: angular.copy(product)
            });
        }

        // notify user
        showProductAddedModal();

        return this.update();
    };

    ShoppingCart.prototype.removeProduct = function (product) {
        //console.log('cart.removeProduct:', product);
        var index = lodash.findIndex(this.products, { id: product.id });
        if (index > -1) {
            this.products.splice(index, 1);
        }
        return this.update();
    };

    ShoppingCart.prototype.pushPayment = function (order, caution, id_session) {
        id_session = typeof id_session  === 'undefined' ? false : id_session;

        if (order.registerType !== 'booking') {
          if (order.paymentChoice === 'card') {
              return drupal.soldPaybox(order, order.registerType === 'advance' ? order.deposit : order.field_total_amount, 'cart', id_session).then(function(data) {
                  if (data.commentaire && data.commentaire !== 'Demande traitée avec succès') {
                      throw data;
                  }
                  if (order.caution > 0 && order.caution < caution) {
                    return drupal.capturePaybox(order, id_session).then(function (data){
                        return data;
                    }).catch(function (error) {
                        // if capture paybox fails, throw specific exception with partial data from sold paybox callback
                        throw {
                            message: 'Paybox capture error',
                            data: data /* data from drupal.soldPaybox */
                        };
                    });
                  }
                  return data;
              });
          }
          else {
              return drupal.updateOpportunityStatus(order);
          }
        }
    };

    ShoppingCart.prototype.getMpiValues = function (order, caution) {
        console.log(this);
        var count = this.products.length + this.internships.length;
        if(this.internships.length){
            this.internships.forEach(function(internship){
                count += internship.field_optionsGuarantees.length;
            })
        }
        console.log(count);
        return drupal.getRemoteMPIValues(order, order.registerType === 'advance' ? order.deposit : order.field_total_amount, 'cart', count).then(function(data) {
            return data;
        });
    };

    ShoppingCart.prototype.notifyMatomo = function () {
        if (window._paq) {
            try {
                var products = []
                this.internships.forEach(function (internship) {
                    products.push([
                        internship.field_internship.product.sfid,
                        internship.field_internship.product.name,
                        internship.field_internship.product.activity,
                        internship.field_internship.price,
                        internship.field_quantity
                    ]);
                    internship.field_optionsGuarantees.forEach(function (option) {
                        products.push([
                            option.sfid,
                            option.name,
                            'option',
                            option.price,
                            option.quantity
                        ]);
                    });
                });
                this.products.forEach(function (product) {
                    products.push([
                        product.field_product.sfid,
                        product.field_product.name,
                        product.field_product.family,
                        product.field_product.price,
                        product.field_quantity
                    ]);
                });

                // Group all product by sfid and sum quantity and price
                var sfids = products.map(function (p) { return p[0]; }).filter(function (value, index, self) { return self.indexOf(value) === index; });
                var uniqueProducts = sfids.map(function (sfid) {
                    var filtered = products.filter(function (p) { return p[0] === sfid; });
                    var price = filtered.reduce(function (a, b) { return a + (b[3] * b[4]); }, 0);
                    var quantity = filtered.reduce(function (a, b) { return a + b[4]; }, 0);
                    return [sfid, filtered[0][1], filtered[0][2], price, quantity];
                });

                uniqueProducts.forEach(function (product) {
                    _paq.push(['addEcommerceItem', product[0], product[1], product[2], product[3], product[4]]);
                });
                _paq.push(['trackEcommerceCartUpdate', this.field_total_amount]);
            } catch (e) { console.error(e); }
        }
    }

    return new ShoppingCart();
}]);
